<template>
  <div class="find" :class="{showFloat}" ref="wrapper">
    <!-- 不展示vip并且状态为1和3时需要这个头 -->
    <!-- <navigation v-if="!showVip && (isQualification===1||isQualification===3)" :showBack="false" class="you-xuan" :theme="{background: '#f7f7f7'}">优选借款</navigation> -->
    <!-- 未登录 -->
    <div class="no-find"  @click="jumpLogin" v-if="!isLogin" v-stat="{id: 10280,target:vipType}">
      <template>
        <img :src="isQualification===1?require('./images/font@2x.png'):require('./images/font_01@2x.png')" :class="['font',{'font-vip':isQualification===3}]" :style="{ 'margin-top': (statusBarHeight || 0) + 'px'}"/>
        <img src="./images/img_faxian_huiyuan@2x.png" class="fa-xian"/>
        <img class="guang" src="./images/img_a@2x.png"/>
        <nd-button class="btn">立即领取</nd-button>
      </template>
    </div>

    <!-- 导流用户 -->
    <template v-if="isQualification===2">
      <navigation :showBack="false" class="you-xuan" :theme="{background: '#f7f7f7'}">优选借款</navigation>
      <pulldown-page
        :refresh="onRefresh"
        :is-scroll="true"
        class="home"
        background="#f7f7f7"
        color="#333333"
      >
        <van-swipe
          v-if="bannerList.length > 0"
          :autoplay="3000"
          :duration="500"
          class="banner"
        >
          <van-swipe-item
            v-for="(item, index) in bannerList"
            :key="index"
            @click="jumpOutLink(item)"
            :data-sensors-exposure-property-product_code="item && item.config ?item.config.configId :''"
            data-sensors-exposure-property-product_type="diversion"
            data-sensors-exposure-event-name="Diversion_Exposure"
            data-sensors-exposure-property-element_positon="product_banner"
          >
            <img :src="item.icon || item.bannerUrl" :alt="item.content" >
          </van-swipe-item>
          <div
            v-if="bannerList.length > 1"
            slot="indicator"
            class="indicator"
          >
            <div
              v-for="(item, index) in bannerList"
              :key="index"
              class="indicator-item"
            />
          </div>
        </van-swipe>
        <find-quick-list :showVip="showVip" v-if="isFind2" position="product_icon"></find-quick-list>
        <quick-list v-else :list="quickList" position="find" ></quick-list>
        <!-- 插队申请（至尊王卡）浮标入口已下线 -->
        <!-- <div class="skc-point"></div> -->
        <div class="river" v-if="borrowList&&borrowList.length>0">
          <div class="borrow">
            <main >
              <p class="title">精选推荐</p>
              <div v-for="(item,index) in borrowList" :key="index" class="item" @click="borrowMoney(item, index)"
                   :data-sensors-exposure-property-product_code="item.configId"
                   data-sensors-exposure-property-element_positon="product_banner"
                   data-sensors-exposure-property-product_type="diversion"
                   data-sensors-exposure-event-name="Diversion_Exposurex"
              >
                <div class="top">
                  <div class="top-left">
                    <img :src="item.icon">
                    <span class="top-left-more">{{item.productName}}</span>
                    <div class="top-left-border" v-if="item.cornerWord">{{item.cornerWord}}</div>
                  </div>
                  <div class="top-right"><span class="red">{{item.loanCounts}}</span>人已借款</div>
                </div>
                <div class="bottom">
                  <div class="bottom-left">
                    <div class="bottom-left-limit">额度高达 (元) </div>
                    <div class="flex-center">
                      <div class="bottom-left-money">{{ item.configLimit|currency }}</div>
                      <div class="bottom-right">{{item.buttonName}}</div>
                    </div>
                    <div class="bottom-left-label">
                      <span>年化利率 {{item.minPrice}}%-{{item.maxPrice}}%,</span>
                      <span>期限{{item.minTerms}}-{{item.terms}}个月</span>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
        <div v-else-if="borrowList" class="none">
          <img src="./images/icon_yihan@2x.png" class="none-img"/>
          <div class="none-title">很遗憾，暂时没有符合您的产品</div>
          <div class="none-next">下次再来逛逛吧～</div>
        </div>
      </pulldown-page>
    </template>

    <!-- 展示会员 -->
    <!--  -->
    <Vip :vipInfo="vipInfo" v-if="showXmVip"></Vip>

    <!-- 空空如也 -->
    <template v-if="isEmpty">
      <div class="no-find no-vip" >
        <img class="no-img" src="./images/img_quesheng@2x.png" alt="">
        <!-- 插队申请（至尊王卡）浮标入口已下线 -->
        <!-- <div class="skc-point"></div> -->
        <p class="no-text">这里空空如也...</p>
      </div>
    </template>
    <!-- <div class="no-find" @click="jumpLogin" v-else-if="isQualification===4" v-stat="{id: 10280,target:vipType}">
      <img src="./images/font_02@2x.png" class="font font-svip" :style="{ 'margin-top': (statusBarHeight || 0) + 'px'}"/>
      <img src="./images/img_faxian_huiyuan02@2x.png" class="fa-xian-svip mt25"/>
      <img class="guang" src="./images/img_a@2x.png"/>
      <div class="content">
        <p class="content-more">更多借款机会，提现成功率达95%</p>
        <div class="content-flex">
          <div class="content-item" v-for="(item,index) in list" :key="index">
            <p class="content-title">{{item.title}}</p>
            <p class="content-content">{{item.content}}</p>
          </div>
        </div>
      </div>
      <nd-button class="btn">立即领取</nd-button>
    </div> -->
    <nd-tabbar :showDotProp="false"></nd-tabbar>
    <template v-if="showVip">
      <div v-if="showFloat" class="float-window" @click="jumpVip">
        <img src="./images/icon_guanbi@2x.png" class="float-close" @click="closeFloat">
      </div>
    </template>
    <!-- 王卡（插队申请浮标）入口已下线 -->
    <!-- <skc id="drag" v-if="showSkc && floatInfo.kingFloat && floatInfo.kingFloat.kingFloatTitle" :kingFloatTitle="floatInfo.kingFloat.kingFloatTitle" :kingGoodsCd="floatInfo.kingFloat.kingGoodsCd"></skc> -->
    <dialog-back v-model="dialogBackVisible"></dialog-back>
    <dialog-back v-model="dialogBackVisible"></dialog-back>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Swipe, SwipeItem } from 'vant'
import { getKey, setKey } from '../../assets/utils'
import QuickList from '@/components/quick-list'
import FindQuickList from './components/quick-list.vue'

import DialogBack from '../home/components/dialog-back'
import Vip from './vip'


export default {
  name: 'page-find',
  customReadyNotify: true,
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    QuickList,
    FindQuickList,
    // 插队申请（至尊王卡）浮标入口已下线
    // skc: () => import('@/components/nd-drag-skc'),
    DialogBack,
    Vip
  },
  data () {
    return {
      // 插队申请（至尊王卡）浮标入口已下线
      // showSkc: false,
      // floatInfo: {},
      deviceInfo: {},
      dialogBackVisible: false,
      showVip: false, // 是否展示VIP
      borrowList: null, // 借款列表
      bannerList: [], // banner展示
      quickList: [], // icon列表
      isQualification: 1, // 1未登录 2 导流
      isLogin: getKey('userInfo', 'token') || '',
      vipType: '', // 判断vip类型
      list: [],
      isFind2: false, // 展示发现页2
      showFloat: false, // 显示浮窗
      showXmVip: false,
      isEmpty: false,
      fundPageType: '',
      memberGoodsCd: '',
      vipInfo: {}
    }
  },
  beforeDestroy () {
    // 插队申请（至尊王卡）浮标入口已下线，滚动收起监听一并移除
    // const $wrapper = this.$refs['wrapper']
    // $wrapper.removeEventListener('scroll', this.shitCat)
  },
  async  created () {
    // 插队申请（至尊王卡）浮标入口已下线，滚动收起监听一并移除
    // this.$nextTick(() => {
    //   const $wrapper = this.$refs['wrapper']
    //   $wrapper.addEventListener('scroll', () => {
    //     this.shitCat()
    //   })
    // })
    if (this.isLogin) {
      this.getLimitX({ loanPlatform: 'TMD' })
      await this.getUserInfoX({ forceUpdate: true })
      const { success, data } = await this.fundPageRoute()
      if (success && data) {
        const { fundPageType, memberGoodsCd } = data
        this.memberGoodsCd = memberGoodsCd
        if (fundPageType === 'DIVERSION') {
          const userStatusRes = await this.getUserStatus({ showPlace: 'DISCOVERY_PAGE' })

          if (userStatusRes.success) {
            const { diversionQualificationType } = userStatusRes.data
            this.showLoanMaket(diversionQualificationType)
          }
        } else {
          if (memberGoodsCd) {
            const memberInfoRes = await this.memberFundPage({
              memberGoods: memberGoodsCd
            })
            if (memberInfoRes.success) {
              this.showVipPage(memberInfoRes)
            }
          } else {
            this.isEmpty = true
          }
        }
      }
    }

    this.$bus.$emit('ready')
    // this.showSkcCheck()
    this.$nextTick(() => {
      document.documentElement.style.overflow = 'hidden'
    })
  },
  beforeCreate () {
    sessionStorage.setItem('showDot', new Date().getTime())
  },
  async mounted () {
    const channel = getKey('channel') || 'official'
    if (this.isIntervalDay(`${channel}HomePopup`, 1)) {
      const { success, data } = await this.queryPopupX({
        showPlace: 'HOME'
      })
      if (success && data) {
        if (data.popupSwitch) {
          // pushState，并且监听popState事件
          window.history.pushState({}, '', window.location.href)
          window.addEventListener('popstate', () => {
            setKey(`${channel}HomePopup`, Date.now())
            this.dialogBackVisible = true
          })
        }
      }
    }
  },
  computed: {
    ...mapState({
      statusBarHeight: state => state.statusBarHeight
    }),
    ...mapState('user', {
      userInfo: (state) => state.userInfo,
      creditStatus: (state) => state.quotaInfo.creditStatus
    })
  },
  methods: {
    // 插队申请（至尊王卡）浮标入口已下线，不再请求 getFloatViewInfo
    ...mapActions('user', ['getBorrowList', 'getUserStatus', 'getUserInfoX', 'getLimitX', 'showStatusX', 'queryPopupX', 'fundPageRoute']),
    ...mapActions(['dataPoint']),
    ...mapActions('vip', [
      'memberInfo',
      'getLockAmount',
      'memberFundPage'
    ]),
    // 插队申请（至尊王卡）浮标入口已下线
    // async showSkcCheck () {
    //   const { success, data } = await this.getFloatViewInfo({
    //     showPlace: 'FUND_PAGE'
    //   })
    //   if (success) {
    //     this.floatInfo = data || {}
    //     if (data.kingFloat && data.kingFloat.kingGoodsCd) {
    //       this.$nextTick(() => {
    //         const $skcTop = document.querySelector('.skc-point')
    //         if ($skcTop) {
    //           sessionStorage.setItem(
    //             'dragPosition',
    //             JSON.stringify({ top: $skcTop.offsetTop - 50 + 'px' })
    //           )
    //           this.showSkc = true
    //         }
    //       })
    //     }
    //   }
    // },
    async showLoanMaket (diversionQualificationType) {
      this.isQualification = 2
      this.$report({
        id: 10002,
        args: {
          screen: diversionQualificationType === 'ONE' ? 'page_find1' : 'page_find2'
        }
      })
      const userInfo = getKey('userInfo')
      this.$sensors.track('find_pageview', {
        page_status: userInfo.limitStatus,
        additinal_status: userInfo.diversionTag
      })
      if (diversionQualificationType === 'TWO') {
        this.isFind2 = true
        if (this.isIntervalDay('river2FLoat', 1)) {
          this.showFloat = true
          setKey('river2FLoat', Date.now())
        }
      }
      await this.init()
    },
    showVipPage (memberFundPage) {
      const { memberFundList } = memberFundPage.data || {}

      if (!(memberFundList && memberFundList.length)) {
        this.isEmpty = true
      } else {
        this.vipInfo = memberFundPage.data || { }
        this.showXmVip = true
      }
    },
    // 插队申请（至尊王卡）浮标入口已下线
    // shitCat () {
    //   const $cat = document.getElementById('drag')
    //   if ($cat) {
    //     const _left = $cat.style.left
    //     const _top = $cat.style.top
    //     if (!this.catOut) {
    //       this.catOut = true
    //       $cat.setAttribute('style', `left:${_left};top:${_top};transform:translateX(${$cat.offsetLeft > 10 ? '180px' : '-300px'})`)
    //     }
    //     clearTimeout(window.timer)
    //     window.timer = setTimeout(() => {
    //       $cat.setAttribute('style', `left:${_left};top:${_top};`)
    //       this.catOut = false
    //     }, 100)
    //   }
    // },
    // 查询vip展示状态
    async queryVipShow () {
      const { success, data } = await this.showStatusX({
        rightsType: 'XM_VIP'
      })
      if (success) {
        this.showVip = data
      }
    },
    jumpLogin () {
      if (!this.showVip) return
      if (!this.isLogin) {
        this.$router.push('/user/login')
      } else if (this.isQualification === 2) {
        this.$router.push({ path: '/river/diversion', query: { source: encodeURIComponent(window.location.href) } })
      } else {
        this.$router.push('/vip/index?target=svip')
      }
    },
    // 初始化
    async init () {
      const response = await this.getBorrowList({ version: 'V2', showPlace: 'DISCOVERY_PAGE', queryBanner: true })
      if (response.success) {
        const { configs, icons, bannerConfigs, bannerConfigsV2 } = response.data
        this.bannerList = (bannerConfigsV2 && bannerConfigsV2.length && bannerConfigsV2) || bannerConfigs || []
        this.quickList = icons || []
        this.borrowList = configs || []
        this.borrowList.map(item => {
          this.$report({
            id: 10002,
            args: { screen: 'river_diversion', step: this.isFind2 ? 'find2' : 'find', target: item.configId }
          })
        })
      }
    },
    // 下拉刷新
    onRefresh () {
      this.init()
    },
    // banner跳转
    jumpOutLink (item = {}) {
      const { config } = item
      if (!config) {
        return this.$router.push('/vip/index')
      }
      this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: 'product_banner', product_code: config.configId })
      this.$report({
        id: 10269,
        args: { target: config.configId, screen: 'river_diversion', step: this.isFind2 ? 'banner2' : 'banner' }
      })
      this.dataPoint(
        {
          id: 10269, screen: 'river_diversion', step: this.isFind2 ? 'banner2' : 'banner', target: config.configId
        }
      )
      const { source } = this.$route.query || {}
      let sourceData = source ? { source } : {}
      const { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = config
      // 同步埋点
      this.$router.push({ path: '/river/middle', query: { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode, ...sourceData } })
    },
    // 去借款
    borrowMoney (item = {}, index) {
      const { source } = this.$route.query || {}
      let sourceData = source ? { source } : {}
      const { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = item
      this.$sensors.track('Diversion_Click', { product_type: 'diversion', element_positon: 'product_list', product_code: configId })
      this.$report({
        id: 10269,
        args: {
          screen: 'river_diversion', status: 'borrowMoney', target: configId, step: this.isFind2 ? 'find2' : 'find', type: index
        }
      })
      this.dataPoint(
        {
          id: 10269, screen: 'river_diversion', status: 'borrowMoney', target: configId, step: this.isFind2 ? 'find2' : 'find', type: index
        }
      )// 同步埋点
      // 跳转太快埋点可能会丢失，所以加了延迟
      setTimeout(() => {
        this.$router.push({ path: '/river/middle', query: { configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode, ...sourceData } })
      }, 300)
    },
    // 跳转VIP
    jumpVip () {
      this.$router.push('/vip/index')
    },
    // 关闭浮窗
    closeFloat (e) {
      e.stopPropagation()
      this.showFloat = false
    }
  }
}
</script>
<style>
.home .page{
  width: 750px;
  height: 100%;
  /* overflow: scroll; */
}
</style>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page{
  padding-bottom: 115px;
}
.find{
    width: 750px;
    height: 100%;
    overflow: scroll;
    /deep/.page{
      background-color: #f7f7f7;
      padding-bottom: 115px;
    }
    &.showFloat{
      /deep/.page{
        padding-bottom: 245px;
      }
    }
  
  .no-find{
    width: 750px;
    height: 100%;
    background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
    box-shadow: inset 0px 3px 9px 0px #FFF4DA;
    padding:150px 0 233px;
    overflow: scroll;
    position: relative;
    &.no-vip{
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .no-img{
        width: 349px;
      }
      .no-text{
        margin-top: 25px;
        color: #666666;
        font-size: 28px;
      }
    }
    .guang{
      position:absolute;
      right:0;
      top:60px;
    }
    .font{
      display:block;
      margin:0 auto 0;
      width:546px;

    }
    .font-vip{
      width:544px !important;
    }
    .font-svip{
      width:490px !important;
    }
    .fa-xian{
      display:block;
      width:750px;
      height:790px;
      margin:0 auto;
    }
    .fa-xian-svip{
      display:block;
      width:750px;
      height:720px;
      margin:0 auto;
      position:relative;
    }
    .mt25{
      margin-top:25px;
    }
    .btn{
      width: 460px;
      height: 94px;
      background: #FF4633;
      border-radius: 47px;
      margin:auto;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }
    .content{
      width: 670px;
      padding:38px 20px 20px;
      background: #FFFFFF;
      box-shadow: 0px 20px 30px 0px rgba(241, 183, 120, 0.3);
      border-radius: 20px;
      margin:-250px auto 46px;
      position:relative;
      z-index:2;
      .content-more{
        height: 42px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #763E12;
        line-height: 42px;
        text-align: center;
        display:flex;
        align-items: center;
        justify-content:center;
        margin-bottom:10px;
      }
      .content-more::before{
        display:inline-block;
        content: '';
        width:36px;
        height: 32px;
        background:url('./images/img_c@2x.png');
        background-size:cover;
        margin-right:20px;
      }
      .content-more::after{
        display:inline-block;
        content: '';
        width:36px;
        height: 32px;
        background:url('./images/img_b@2x.png');
        background-size:cover;
        margin-left:20px;
      }
      .content-flex{
        display:flex;
        flex-wrap: wrap;
        justify-content:space-between;
      }
      .content-item{
        width: 305px;
        padding:20px 0 18px;
        background: #FFF2E5;
        box-shadow: inset 0px 3px 10px 0px #FFF4DA;
        border-radius: 10px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        margin-top:20px;
        .content-title{
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 40px;
        }
      }
    }
  }
    .banner {
        width: 690px;
        height: 250px;
        margin: 0 auto;
        margin-top: 30px;
        position: relative;
        border-radius:20px;
        .van-swipe-item {
            width: 690px;
            height: 250px;
        }
        img {
            width: 100%;
            height: 100%;
        }

        .indicator {
            position: absolute;
            bottom: 16px;
            display: flex;
            flex-direction: row;
            left: 50%;
            transform: translateX(-50%);

            .indicator-item {
                width: 16px;
                height: 4px;
                background-color: #fff;
                opacity: 0.5;
                border-radius: 2px;

                & + .indicator-item {
                    margin-left: 14px;
                }

                &.active {
                    opacity: 1;
                }
            }
        }
    }
    .river{
      overflow: auto;
    }
    .borrow{
      width: 690px;
      background: #EBF0F9;
      border-radius: 20px;
      padding:50px 0 50px;
      margin:30px auto 0;
      overflow: auto;
      main{
        .title{
          font-size: 38px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          padding-left:40px;
        }
        .item{
          width: 630px;
          background: #FFFFFF;
          border-radius: 10px;
          margin:20px auto 0;
          padding:0 30px;
          .top{
            height:110px;
            border-bottom:1px solid #EEE;
            display: flex;
            align-items:center;
            justify-content:space-between;
            &-left{
              display: flex;
              justify-content:space-between;
              align-items:center;
              &-more{
                margin-left:14px;
              }
              >img{
              width:60px;
              height:60px;
              border-radius: 10px;
              }
              &-border{
                margin-left:10px;
                max-width: 200px;
                line-height: 34px;
                text-align: center;
                border-radius: 4px;
                border: 1px solid #FF4633;
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FF4633;
                padding:0 5px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
            &-right{
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }
            .red{
              color:red;
            }
          }
          .bottom{
            // display: flex;
            // justify-content: space-between;
            // align-items:center;
            // height: 210px;
            padding:39px 0;
            &-left{
              display: flex;
              flex-direction:column;
              align-items:space-between;
              justify-content: center;
              // height: 85px;
              // width:400px;
              &-limit{
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }
              &-money{
                font-size: 40px;
                font-family: DIN-Medium, DIN;
                font-weight: 500;
                color: #333333;
              }
              &-label{
                // width: 288px;
                padding-top:17px;
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }
              .flex-center{
                display: flex;
                justify-content:space-between;
                align-items: center;
                .bottom-right{
                  width: 170px;
                  height: 60px;
                  line-height: 60px;
                  text-align:center;
                  background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                  border-radius: 30px;
                  font-size: 28px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #FFFFFF;
                  height:60px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
            }
          }
        }
      }
    }
    .none{
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top:140px;
      // min-height:800px;
      &-img{
        width:140px;
        height:140px;
        display:block;
      }
      &-title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-top:40px;
      }
      &-next{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-top:9px;
      }
    }
    footer{
      padding:50px 0 175px;
      text-align:center;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    .float-window{
      position: fixed;
      bottom: 122px;
      z-index: 99;
      width: 690px;
      height: 106px;
      left: 50%;
      transform: translateX(-50%);
      background: url(./images/img_fuchuang@2x.png) center no-repeat;
      background-size: 100%;
      .float-close{
        width: 18px;
        height: 18px;
        position: absolute;
        right: 35px;
        top: 66px;
      }
    }
}
</style>